import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LogoutPage = () => {
  const { logout } = useAuth0();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-purple-100 to-blue-200">
      <div className="bg-white rounded-2xl shadow-2xl px-10 py-12 flex flex-col items-center">
        <h2 className="text-2xl font-bold mb-2 text-gray-800">Ready to Log Out?</h2>
        <p className="text-gray-500 mb-8 text-center">
          You’re about to log out of your account.<br />
          See you next time!
        </p>
        <button
          onClick={() =>
            logout({ logoutParams: { returnTo: window.location.origin } })
          }
          className="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-3 px-6 rounded-xl transition-all duration-150 shadow-md focus:outline-none"
        >
          Log Out
        </button>
      </div>
    </div>
  );
};

export default LogoutPage;
